import React from 'react'
import { connect } from 'react-redux'
import FileUploader from '../../Containers/FileUploader'
import BannerActions from '../../Redux/BannerRedux'

class FormCreate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        type: 'travypass',
        title: '',
        priority: 1,
        image_file: {
          web: '',
          mobile: '',
          original: ''
        },
        link: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value.replace(/[^\x20-\x7E]/g, '')
    if (event.target.type === 'number') {
      val = parseInt(val, 10)
    }
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _fileUploaded = (filename, field) => {
    let form = {...this.state.form}
    form.image_file[field] = filename
    if (field === 'web') {
      form.image_file['original'] = filename
    }
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    this.props.createBanner(this.state.form)

    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseFloat(val) > 1000) {
      val = 1000
    } else if (parseFloat(val) < 1) {
      val = 1
    }
    let form = {...this.state.form}
    form.priority = val
    this.setState({ form })
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Register New Banner</h4>
        </div>

        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Banner Title' className='form-control' value={this.state.form.title} onChange={(event) => this._inputChange(event, 'title')} />
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Priority</label>
            </div>
            <div className='col-9'>
              <input type='number' required className='form-control' value={this.state.form.priority} onChange={(event) => this._valueChange(event)} />
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Link</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Banner Link' className='form-control' value={this.state.form.link} onChange={(event) => this._inputChange(event, 'link')} />
              <small className='form-text text-muted'>URL must contain https://</small>
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Banner Web (<span className='text-orange'>1049x433</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader required setting={{ type: 'banner' }} onUploaded={(filename) => this._fileUploaded(filename, 'web')} />
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Banner Mobile (<span className='text-orange'>335x320</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader required setting={{ type: 'banner' }} onUploaded={(filename) => this._fileUploaded(filename, 'mobile')} />
            </div>
          </div>

          <div className='form-group d-flex justify-content-end'>
            <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
            <button
              className='btn btn-lg btn-primary'
              type='submit'
            >
              Save
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  createBanner: (data) => dispatch(BannerActions.bannerCreateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormCreate)



// WEBPACK FOOTER //
// ./src/Containers/Travypass/FormCreate.js